




















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import RegraDeCalculoForm from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/RegraDeCalculoForm.vue'
import ProcedimentosDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ProcedimentosDataTable.vue'
import ProcedimentoCompartilhadoDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ProcedimentoCompartilhadoDataTable.vue'
import ContratosDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ContratosDataTable.vue'
import OperadorasDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/OperadorasDataTable.vue'
import ProcedimentosDescartarDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ProcedimentosDescartarDataTable.vue'
import PlanoDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/PlanoDataTable.vue'
import FiltroPorProcedimento from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/FiltroPorProcedimento.vue'
import EquipesProfissionalDataTable from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/EquipesProfissionalDataTable.vue'
import EventBus from '@/plugins/EventBus'
import LocaisExecucaoDataTable from './LocaisExecucaoDataTable.vue'
import SetorAtendimentoDataTable from './SetorAtendimentoDataTable.vue'

@Component({
  components: {
    RegraDeCalculoForm,
    ContratosDataTable,
    OperadorasDataTable,
    LocaisExecucaoDataTable,
    ProcedimentosDescartarDataTable,
    ProcedimentosDataTable,
    ProcedimentoCompartilhadoDataTable,
    PlanoDataTable,
    SetorAtendimentoDataTable,
    FiltroPorProcedimento,
    EquipesProfissionalDataTable,
  },
})
export default class ComponentModalFinanceiroRegraDeCalculo extends Vue {
  $refs!: { tabs: any }

  regraDeCalculo = {
    validate: false,
    isValid: false,
  }

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get mode() { return this.getRegrasDeCalculoStore.mode }
  get showModalFinanceiroRegraDeCalculo() { return this.getRegrasDeCalculoStore.modal.regraDeCalculo }
  set showModalFinanceiroRegraDeCalculo(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculo', value }) }

  loadSaveOrUpdateRegraDeCalculo: boolean = false
  get loadingSaveOrUpdateRegraDeCalculo() { return this.loadSaveOrUpdateRegraDeCalculo }
  set loadingSaveOrUpdateRegraDeCalculo(value: boolean) { this.loadSaveOrUpdateRegraDeCalculo = value }

  get validateRegraDeCalculo() { return this.regraDeCalculo.validate }
  set validateRegraDeCalculo(value: any) { this.regraDeCalculo.validate = value }

  get isValidRegraDeCalculoForm() { return this.regraDeCalculo.isValid }
  set isValidRegraDeCalculoForm(value: any) { this.regraDeCalculo.isValid = value }

  @Watch('isValidRegraDeCalculoForm')
  async onValidateRegraDeCalculoForm(valid) {
    if (valid) {
      await this.saveOrUpdateRegraDeCalculo()
    }
  }

  @Watch('showModalFinanceiroRegraDeCalculo')
  async onShowModalFinanceiroRegraDeCalculo(show: boolean) {
    if (show) {
      await this.showModal(true, '')
    }
  }

  async validateForm() {
    this.validateRegraDeCalculo = true

    if (this.tabs === 'tab-1' && !this.isValidRegraDeCalculoForm) {
      return
    }

    await this.saveOrUpdateRegraDeCalculo()
  }

  async saveOrUpdateRegraDeCalculo() {
    this.loadingSaveOrUpdateRegraDeCalculo = true

    const request = await this.getRegrasDeCalculoStore.upsertRegraCalculo()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message || `Ocorreu um erro ao ${this.mode === 'CREATE' ? 'salvar' : 'alterar'} a regra`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingSaveOrUpdateRegraDeCalculo = false
      this.validateRegraDeCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Regra ${this.mode === 'CREATE' ? 'gravada' : 'alterada'} com sucesso!`,
      icon: 'done',
      color: '#2E7D32',
    })

    this.validateRegraDeCalculo = false
    this.loadingSaveOrUpdateRegraDeCalculo = false
  }

  /** TABS */

  tb: string = 'tab-1'
  get tabs() { return this.tb }
  set tabs(value: string) { this.tb = value }

  async tabChange(e: string) {
    let tab = ''
    switch (e) {
      case 'tab-1':
        tab = 'regra'
        break
      case 'tab-2':
        tab = 'contratos'
        break
      case 'tab-3':
        tab = 'operadoras'
        break
      case 'tab-4':
        tab = 'locais-execucao'
        break
      case 'tab-5':
        tab = 'setor-atendimento'
        break
      case 'tab-6':
        tab = 'procedimentos-descartar'
        break
      case 'tab-7':
        tab = 'procedimentos'
        break
      case 'tab-8':
        tab = 'procedimento-compartilhado'
        break
      case 'tab-9':
        tab = 'plano'
        break
      case 'tab-10':
        tab = 'filtro-procedimento'
        break
      case 'tab-11':
        tab = 'equipes-profissional'
        break
      default:
        tab = 'regra'
    }

    this.$nextTick(async () => {
      if (tab === 'regra') {
        //
      }

      if (tab === 'contratos') {
        this.getRegrasDeCalculoStore.setPrestadorId('')
        this.getRegrasDeCalculoStore.clearPrestadores()
        this.getRegrasDeCalculoStore.clearContratos()
        await this.getRegrasDeCalculoStore.getPrestadorContratoCliente()
        // await this.getRegrasDeCalculoStore.getProfissionalContratoCliente()
        await this.getRegrasDeCalculoStore.getPrestadoresContratoByRegraCalculoId()
      }

      if (tab === 'operadoras') {
        this.getRegrasDeCalculoStore.clearPessoaOperadoras()
        this.getRegrasDeCalculoStore.clearClassificacaoOperadoras()
        await this.getRegrasDeCalculoStore.getPessoaOperadoraAll()
        await this.getRegrasDeCalculoStore.getClassificacaoOperadoraAll()
      }

      if (tab === 'procedimentos-descartar') {
        this.getRegrasDeCalculoStore.clearProcedimentoDescartar()
      }
    })
  }

  get isEdit() {
    return this.getRegrasDeCalculoStore.regraDeCalculo.id
  }

  get filtraPorProcedimento() {
    return this.getRegrasDeCalculoStore.regraDeCalculo.filtraPorCodigoProcedimento
  }

  get filtraPorEquipeProfissional() {
    return this.getRegrasDeCalculoStore.regraDeCalculo.filtraPorEquipeProfissional
  }

  get showOperadoraTab() {
    if (!this.getRegrasDeCalculoStore.regraDeCalculo.id) return false
    return this.getRegrasDeCalculoStore.regraDeCalculo.filtraPorOperadora
  }

  get showLocaisExecucao() {
    if (!this.getRegrasDeCalculoStore.regraDeCalculo.id) return false
    return this.getRegrasDeCalculoStore.regraDeCalculo.filtraPorLocalExecucao
  }

  get showSetorAtendimento() {
    if (!this.getRegrasDeCalculoStore.regraDeCalculo.id) return false
    return this.getRegrasDeCalculoStore.regraDeCalculo.filtraPorSetorAtendimento
  }

  get showProcedimentos() {
    return this.getRegrasDeCalculoStore.regraDeCalculo.id
  }

  loadCloseButton: string = ''
  get loadingCloseButton() { return this.loadCloseButton }
  set loadingCloseButton(value: string) { this.loadCloseButton = value }

  async showModal(show: boolean, closeButton: 'top' | 'bottom' | '') {
    if (show) {
      await this.$nextTick()
      this.$refs.tabs.callSlider()

      if (this.mode === 'CREATE') {
        this.getRegrasDeCalculoStore.setRegraDeCalculoField({ field: 'ativo', value: true })
      }
    }

    if (!show) {
      this.loadingCloseButton = closeButton
      await this.getRegrasDeCalculoStore.getRegraCalculoAll(this.getRegrasDeCalculoStore.paginacaoRegrasDeCalculo)
      this.loadingCloseButton = ''

      this.getRegrasDeCalculoStore.setMode('CREATE')
      this.getRegrasDeCalculoStore.setRegraDeCalculoId('')
      this.getRegrasDeCalculoStore.clearRegraDeCalculo()
      this.getRegrasDeCalculoStore.clearRegraDeCalculoContrato()
      this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
      this.getRegrasDeCalculoStore.clearPrestadoresSearchList()
      this.getRegrasDeCalculoStore.setPrestadorIdSearch('')
      this.getRegrasDeCalculoStore.clearContratos()
      this.getRegrasDeCalculoStore.setPrestadorId('')
      this.getRegrasDeCalculoStore.clearContratosId()
      this.getRegrasDeCalculoStore.clearPessoaOperadoras()
      this.getRegrasDeCalculoStore.clearClassificacaoOperadoras()
      this.getRegrasDeCalculoStore.clearPessoaOperadoraAIncluir()
      this.getRegrasDeCalculoStore.clearClassificacaoOperadoraAIncluir()
      this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
      this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
      this.tabs = 'tab-1'

      this.showModalFinanceiroRegraDeCalculo = false
    }
  }

}
